// src/components/pages/RecordingCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // adjust if your path differs

export default function RecordingCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 1.jpg`,  alt: 'Recording Studio 1' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 2.jpg`,  alt: 'Recording Studio 2' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 3.jpg`,  alt: 'Recording Studio 3' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 4.jpg`,  alt: 'Recording Studio 4' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 5.jpg`,  alt: 'Recording Studio 5' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 8.jpg`,  alt: 'Recording Studio 8' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 10.jpg`, alt: 'Recording Studio 10' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 13.jpg`, alt: 'Recording Studio 13' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 19.jpg`, alt: 'Recording Studio 19' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 21.jpg`, alt: 'Recording Studio 21' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
    />
  );
}
